import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1041',
    ecrans: ['00-2']
});
